import ClearingAPI from '@shared/api';

export const {
    achRelationships: { get: getACHRelationships },
} = ClearingAPI.settings;
